// eslint-disable-next-line import/prefer-default-export
export const orderTypeDisplayName = {
  newest: 'Newest',
  unanswered: 'Unanswered',
  active: 'Active',
  mostViewed: 'Most Viewed',
  saved: 'Saved',
  trending: 'Trending',
} as const;
